export const REF_DATE_FORMAT = 'DD-MM-YYYY HH:mm:ss';

// Display API clock fields as supplied; never apply the browser timezone.
// Date/epoch callers have no original offset, so their UTC ISO fields are used.
export function formatRefDate(value) {
    if (value instanceof Date || typeof value === 'number') {
        const date = value instanceof Date ? value : new Date(value);
        if (!Number.isFinite(date.getTime())) return '—';
        value = date.toISOString();
    }
    if (typeof value !== 'string') return '—';
    const match = /^(\d{4})-(\d{2})-(\d{2})[T ](\d{2}):(\d{2}):(\d{2})(?:\.\d+)?(?:Z|[+-](\d{2}):?(\d{2}))?$/.exec(value.trim());
    if (!match) return '—';
    const [, year, month, day, hour, minute, second, offsetHour, offsetMinute] = match;
    const y = Number(year), m = Number(month), d = Number(day);
    const leap = y % 4 === 0 && (y % 100 !== 0 || y % 400 === 0);
    const days = [31, leap ? 29 : 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
    if (y < 1 || m < 1 || m > 12 || d < 1 || d > days[m - 1]
        || Number(hour) > 23 || Number(minute) > 59 || Number(second) > 59
        || Number(offsetHour || 0) > 23 || Number(offsetMinute || 0) > 59) return '—';
    return `${day}-${month}-${year} ${hour}:${minute}:${second}`;
}

export const formatRefDateRows = rows => rows.map(row => ({ ...row, RefDate: formatRefDate(row.RefDate) }));
